import { getLogger } from "@expert/logging";
import type { Partner } from "@expert/shared-types";
import { useQuery } from "@tanstack/react-query";
import { getCallIntroFlowQuestions } from "../api/getCallIntroFlowQuestions";
import { useContentfulClient } from "../ContentfulClientProvider";

const logger = getLogger({
    module: "call-intro-flow-questions",
    supportTeam: "sales",
});
export const useCallIntroFlowQuestions = (partner: Partner) => {
    const contentfulClient = useContentfulClient();
    const { data, error } = useQuery({
        queryKey: ["call-intro-flow-questions", partner],
        queryFn: async () => await getCallIntroFlowQuestions(contentfulClient, partner),
    });
    if (error) {
        logger.info({ partner }, "Failed to find call intro flow questions");
        return undefined;
    }
    return data;
};
